import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TenantUsersPage } from "@/features/tenant/UsersPage";

export const Route = createFileRoute("/app/tenant/users")({
  validateSearch: z.object({
    open: z.string().optional(),
    create: z.coerce.number().optional().catch(undefined),
  }),
  component: TenantUsersPage,
});
